import React, { useLayoutEffect, useState } from 'react';
import { ICountry } from 'interfaces';
import { locationSelectors } from 'redux/modules/Location';
import { useAppSelector } from 'redux/hooks';
import { CitySelector, CountrySelector } from './components';

type LocationSelectorsProps = {
  checkSelection?: (isSelected: boolean) => void;
  includeLocationIcons?: boolean;
};

export const LocationSelectors = ({
  checkSelection,
  includeLocationIcons,
}: LocationSelectorsProps) => {
  const currentLocation = useAppSelector(locationSelectors.getCurrentLocation);
  const [country, setCountry] = useState<ICountry | undefined>(
    currentLocation?.country,
  );
  const [isCitySelected, setIsCitySelected] = useState<boolean>(
    !!currentLocation?.cityName,
  );

  useLayoutEffect(
    () => checkSelection?.(isCitySelected && !!country),
    [country, isCitySelected],
  );

  return (
    <>
      <CountrySelector
        changeCountry={(selectedCountry: ICountry) => {
          setCountry(selectedCountry);
          setIsCitySelected(false);
        }}
        country={country}
        includeLocationIcon={includeLocationIcons}
      />
      <CitySelector
        country={country}
        handleCityChange={(boolean: boolean) => setIsCitySelected(boolean)}
        includeLocationIcon={includeLocationIcons}
        disabled={!country}
      />
    </>
  );
};
